// Settings → Dimension values (V-10): the Application API's routes for each Dimension's values, which run the same
// commands chat runs (#603).
import { call, type Fetch } from "../../http.js";

/** What the person's Roles let them do to a list on Settings: only those buttons show. */
export interface ListMay {
  readonly add: boolean;
  readonly rename: boolean;
  readonly retire: boolean;
}

/** One value of a Dimension, with the Counterparty it stands for (its name when the person may read it). */
export interface DimensionValue {
  readonly id: string;
  readonly dimension: string;
  readonly name: string;
  readonly code: string | null;
  readonly counterparty: { readonly id: string; readonly name: string | null } | null;
  readonly retired: boolean;
}

export interface DimensionValues {
  readonly may: ListMay;
  readonly dimensions: readonly {
    readonly id: string;
    readonly label: string;
    readonly values: readonly DimensionValue[];
  }[];
}

export interface DimensionValuesApi {
  list(): Promise<DimensionValues>;
  add(input: { dimension: string; name: string; code?: string }): Promise<DimensionValue>;
  rename(value: string, name: string): Promise<DimensionValue>;
  retire(value: string): Promise<DimensionValue>;
}

export function createDimensionValuesApi(fetcher: Fetch): DimensionValuesApi {
  return {
    list: () => call<DimensionValues>(fetcher, "/api/settings/dimension-values"),
    add: (input) => call<DimensionValue>(fetcher, "/api/settings/dimension-values", { json: input }),
    // Each path written out whole: tests/api-routes/ checks every one the web app calls is one the api serves.
    rename: (value, name) =>
      call<DimensionValue>(fetcher, `/api/settings/dimension-values/${encodeURIComponent(value)}/rename`, {
        json: { name },
      }),
    retire: (value) =>
      call<DimensionValue>(fetcher, `/api/settings/dimension-values/${encodeURIComponent(value)}/retire`, {
        json: {},
      }),
  };
}
